// Plain-English messages for the eRound provisioning actions (SOPS-148).
//
// station-ops answers with { timestamp, message, status, path } and no error
// code, and its message embeds internal state names. As in
// stationConfigErrors.ts, the wording is derived from the HTTP status and the
// action. A 409 needs the record re-read to say which conflict it was; that
// happens in the dialog (research R3), so here it only gets a fallback.

export type ProvisioningAction = "load" | "approve" | "reject" | "retry" | "map" | "ladeverbund" | "handled";

const status = (err: any): number | undefined => err?.response?.status;

const FAILED: Record<ProvisioningAction, string> = {
  load: "The eRound status could not be loaded",
  approve: "The station could not be approved",
  reject: "The request could not be rejected",
  retry: "The station could not be sent again",
  map: "The wallbox model could not be saved",
  ladeverbund: "The Ladeverbund mark could not be saved",
  handled: "The manual step could not be marked as handled",
};

export const provisioningErrorMessage = (err: any, action: ProvisioningAction): string => {
  switch (status(err)) {
    case 400:
      return action === "map"
        ? "Enter eRound's manufacturer and model, and at least one charging point."
        : action === "reject"
          ? "Enter a reason of at most 500 characters."
          : `${FAILED[action]}: the request was incomplete.`;
    case 403:
      return "You are not allowed to do this.";
    case 404:
      return "This station is no longer tracked for eRound. Reload the page.";
    case 409:
      return `${FAILED[action]}: it changed in the meantime. Reload and check it again.`;
    case undefined:
      return `${FAILED[action]}: station-ops could not be reached. Please try again.`;
    default:
      return `${FAILED[action]}. Please try again.`;
  }
};
